import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10.5,
	height: 12,
	viewBox: "0 0 10.5 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M10.5,11.25c0,.41-.34,.75-.75,.75H.75c-.41,0-.75-.34-.75-.75,0-2.28,1.85-4.12,4.12-4.12h2.25c2.28,0,4.12,1.85,4.12,4.12Zm-1.15-.38c-.19-1.48-1.45-2.62-2.98-2.62h-2.25c-1.53,0-2.79,1.15-2.98,2.62H9.35ZM2.25,3C2.25,1.34,3.59,0,5.25,0s3,1.34,3,3-1.34,3-3,3-3-1.34-3-3Zm1.12,0c0,1.03,.84,1.88,1.88,1.88s1.88-.84,1.88-1.88-.84-1.88-1.88-1.88-1.88,.84-1.88,1.88Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgProfile);
export default ForwardRef;
